module.exports = "https://static.wanderu.com/ui-react/_next/static/media/wanderu-logo.e19fc775.svg";